import React from "react";
export default function DescriptionField({ id, description }) {
    if (description) {
        return (React.createElement("div", null,
            React.createElement("div", { id: id, className: "mb-4" }, description)));
    }
    return null;
}
//# sourceMappingURL=DescriptionField.js.map